import styled, { css } from "styled-components";

import { lg, md, sm, xl, xxl } from "./breakpoint";

export const Container = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 35px;
  ${xxl(
    css`
      max-width: 1320px;
    `
  )}
  ${xl(css`
    max-width: 960px;
  `)} 
  ${lg(css`
    max-width: 720px;
  `)}
  ${md(css`
    max-width: 540px;
  `)}
  ${sm(css`
    max-width: 100%;
  `)}
`;

export const ContainerFluid = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding-left: 30px;
  padding-right: 30px;
`;
